import { BaseSecondSidebarPageContent } from "../../shared/components/base/page/BaseSecondSidebarPageContent";
import { IConnectRender } from "../../shared/components/definitions/IConnectRender";
import { AplicacionesMapRender } from "../../shared/components/modulos/aplicaciones/map/AplicacionesMapRender";
import { AplicacionesSecondSidebarRender } from "../../shared/components/modulos/aplicaciones/sidebar/AplicacionesSecondSidebarRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import { APP_RUTA_FINCA } from "../components/ClienteAsideMenuRender";

/** Página del módulo de aplicaciones: segundo sidebar (aplicaciones por año,
 *  detalle expandible) + mapa con el vuelo de la aplicación seleccionada. */
export class AplicacionesPage extends BaseSecondSidebarPageContent {
  /** Mapa vivo de la página (el sidebar le cambia la aplicación mostrada). */
  private _mapRender: AplicacionesMapRender | null = null;

  /** El mapa de aplicaciones (contenido principal). */
  protected getMainRender(): IConnectRender {
    this._mapRender = new AplicacionesMapRender();
    return this._mapRender;
  }

  /** Sidebar de aplicaciones: volver → mapa de finca; selección → vuelo. */
  protected getSecondSidebarRender(): IConnectRender {
    return new AplicacionesSecondSidebarRender(
      () => serviceProvider.getLayoutService().navigate(APP_RUTA_FINCA),
      (aplicacion) => this._mapRender?.setAplicacion(aplicacion),
    );
  }
}
